import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import pure from '../../lib/pure';
import * as styles from './styles.css';

const getCustomTag = (onClick, href, link) => {
  if (href) {
    return 'a';
  }
  if (link) {
    return Link;
  }
  return 'button';
};

function Btn({
  blank,
  children,
  className,
  disabled,
  href,
  icon,
  iconInverse,
  iconStyle,
  link,
  onClick,
  handleRef,
  size,
  stretch,
  type,
  variant,
  onMouseOver,
  onMouseOut,
  testID,
  title,
  noStyle,
  center,
}) {
  const typeClassName = variant ? `btn-${variant}` : 'btn-default';
  const sizeClassName = size ? `btn-${size}` : '';
  const stretchClassName = stretch ? 'btn-block' : '';
  const iconStyleClassName = iconStyle ? `text-${iconStyle}` : '';
  const iconInverseStyle = iconInverse ? 'fa-inverse' : '';

  const CustomTag = getCustomTag(onClick, href, link);
  return (
    <CustomTag
      disabled={disabled}
      onClick={onClick ? (event) => {
        event.stopPropagation();
        return onClick(event);
      } : undefined}
      className={classNames(
        'btn',
        typeClassName,
        sizeClassName,
        styles.button,
        stretchClassName,
        className,
        {
          [styles.buttonFlex]: !noStyle,
          [styles.centerButton]: center,
        },
      )}
      type={type}
      ref={handleRef}
      data-testid={testID}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      title={title}
      href={!disabled ? href : undefined}
      to={!disabled ? link : undefined}
      target={blank ? '_blank' : undefined}
      {...disabled}
    >
      {icon && <i className={`fa fa-${icon} ${iconStyleClassName} ${iconInverseStyle}`} />}
      {children && <span>{children}</span>}
    </CustomTag>
  );
}

Btn.defaultProps = {
  blank: undefined,
  type: 'button',
  children: undefined,
  className: '',
  disabled: false,
  href: undefined,
  size: undefined,
  iconStyle: undefined,
  iconInverse: false,
  link: undefined,
  icon: undefined,
  onClick: undefined,
  handleRef: undefined,
  variant: undefined,
  stretch: false,
  onMouseOver: undefined,
  onMouseOut: undefined,
  testID: undefined,
  title: undefined,
  noStyle: false,
  center: false,
};

Btn.propTypes = {
  blank: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit']),
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.string,
  iconInverse: PropTypes.bool,
  iconStyle: PropTypes.oneOf(['default', 'success', 'primary', 'warning', 'danger']),
  link: PropTypes.string,
  onClick: PropTypes.func,
  handleRef: PropTypes.func,
  stretch: PropTypes.bool.isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'lg']),
  variant: PropTypes.oneOf(['default', 'success', 'primary', 'danger', 'warning']),
  onMouseOver: PropTypes.func,
  onMouseOut: PropTypes.func,
  testID: PropTypes.string,
  title: PropTypes.string,
  noStyle: PropTypes.bool,
  center: PropTypes.bool,
};

const Button = pure(Btn);
export default Button;
export const ButtonSmall = pure(props => <Button {...props} size="xs" />);
